import $ from 'jquery';

export const elements = {
    holder: '.js-Checkbox-Holder, .js-Radio-Holder',
};

$.fn.inputSetState = () => (
    $(elements.holder).each(function () {
        const $t = $(this);
        const input = $t.find('input:checked');
        return input.parent(elements.holder).addClass('fn-active');
    })
);

export default $;



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/utils/jquery/input-set-state.js